import { z } from 'zod/v3';
import { SopStatusSchema } from '../generated/enums';

export const SopDTOSchema = z.object({
  id: z.string(),
  workspaceId: z.string(),
  flowId: z.string().nullable(),
  title: z.string(),
  description: z.string().nullable(),
  content: z.any().nullable(), // TipTap JSON
  status: SopStatusSchema,
  createdById: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  applicationName: z.string().nullable().optional(),
  applicationFavicon: z.string().nullable().optional(),
});

export type SopDTO = z.infer<typeof SopDTOSchema>;

export const CreateSopDTOSchema = z.object({
  title: z.string(),
  description: z.string().optional(),
  flowId: z.string().optional(),
});

export type CreateSopDTO = z.infer<typeof CreateSopDTOSchema>;

export const UpdateSopContentDTOSchema = z.object({
  id: z.string(),
  content: z.any(),
});

export type UpdateSopContentDTO = z.infer<typeof UpdateSopContentDTOSchema>;

export const UpdateSopMetaDTOSchema = z.object({
  id: z.string(),
  title: z.string().optional(),
  description: z.string().optional().nullable(),
  status: SopStatusSchema.optional(),
  applicationName: z.string().optional().nullable(),
  applicationFavicon: z.string().optional().nullable(),
});

export type UpdateSopMetaDTO = z.infer<typeof UpdateSopMetaDTOSchema>;

// Cross-workspace SOP listing (for My Space dashboard)
export const SopListItemDTOSchema = z.object({
  id: z.string(),
  workspaceId: z.string(),
  title: z.string(),
  description: z.string().nullable(),
  status: SopStatusSchema,
  createdById: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  workspace: z.object({
    id: z.string(),
    title: z.string(),
    slug: z.string(),
    color: z.string().nullable(),
  }),
});

export type SopListItemDTO = z.infer<typeof SopListItemDTOSchema>;

export const ListAllSopsFilterSchema = z.enum(['ALL', 'MINE', 'SHARED_WITH_ME']);
export type ListAllSopsFilter = z.infer<typeof ListAllSopsFilterSchema>;
